module.exports = __webpack_public_path__ + "static/media/razor_shark.push.dd1bad2e.jpeg";